import { Component, ErrorHandler, OnInit, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';


@Component({
  selector: 'app-against-notification-form3',
  templateUrl: './against-notification-form3.component.html',
  styleUrls: ['./against-notification-form3.component.css']
})
export class AgainstNotificationForm3Component implements OnInit {
app: any = {};
  data: any;
  Banks: any;
   formInvalid = false;
  APP_Reg_No: any;
   isLoading = false;
   r:any={};
  App_Reg_No: any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) {
  }

  ngOnInit() {
   this.GetAllBanksforapplication();
    this.route.queryParams.subscribe(params => {
    //this.App_Reg_No = params['App_Reg_No'];
     this.App_Reg_No = params['App_Reg_No'];

    // ← Guard
    if (!this.App_Reg_No || !sessionStorage.getItem('step2Completed')) {
      this.router.navigate(['/applicant-register']);
      return;
    }
    sessionStorage.removeItem('step2Completed');  // ← consume
  
    console.log('Received App No:', this.App_Reg_No);

    // assign to your model
    this.app.App_Reg_No = this.App_Reg_No;
    this.GetByIdVerifybankdetails();
  });
  }
  
GetByIdVerifybankdetails() {

  if (!this.App_Reg_No) {
    console.error('App_Reg_No is missing');
    return;
  }

  document.getElementById('loader-spinner').style.display = "block";

  this.userService.GetByIdverificationbankdetais(this.App_Reg_No)
    .subscribe(
      (response: any) => {

        console.log("Full API Response:", response);

        if (response && response.data) {

          this.r = response.data;   // ✅ FIXED

          this.app.APP_BankBranch = this.r.APP_BankBranch;
          this.app.branchcode = this.r.branchcode;
          this.app.APP_IFSC = this.r.APP_IFSC;
          this.app.APP_AccountNo = this.r.APP_AccountNo;

        }

        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
}



    GetAllBanksforapplication() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllBanksforapplication();
    this.data.subscribe(
      (response: any) => {
        this.Banks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }








SaveStep3(form: NgForm) {
debugger
  if (form.invalid) {
    this.formInvalid = true;
    return;
  }

  this.formInvalid = false;
  this.isLoading = true;

  this.userService
    .Step3_UpdateBankDetails(this.app)
    .subscribe({
      next: (res: any) => {
        this.isLoading = false;

        swal('Success!', 'Bank Details are Saved Successfully, Please continue with Step4', 'success');
        sessionStorage.setItem('step3Completed', '1');
        // Navigate to next step page
       
this.router.navigate(
  ['/against-notification-form4'],
  { 
    queryParams: { 
      App_Reg_No: res.App_Reg_No,
      IsJoint: res.IsJoint,
      Ex_Servicemen: res.Ex_Servicemen,
      Disability: res.Disability,
      CA_Id_Fk: res.CA_Id_Fk
    } 
  }
);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error saving data', err);
        alert('Something went wrong!');
      }
    });
}
}




// WEBPACK FOOTER //
// ./src/app/registration/against-notification-form3/against-notification-form3.component.ts